<template>
	<div v-if="(isActive || selected) && ! disablePayInStore" class="list-group-item col-xs-12" :class="{ active: selected && isActive}">
		<div class="col-xs-12 pl-0 pr-0 mb-4">
			<label class="radio-checkbox-label radio-inline col-xs-12 pr-0">
				<input class="checkbox" type="radio" :checked="selected" />
				<span class="checkbox-custom" >
					<span v-if="selected && isActive" class="checkbox-dot" />
					<span v-else-if="selected && ! isActive" class="glyphicon glyphicon-ok ok-mark" />
				</span>
				<span style="font-weight: bold;" class="ml-3">{{ paymentMethod.id === 35 && hasPartPaymentOptions ? 'Delbetala från ' + getLowestResursCost + ' / mån' : paymentMethod.id === 36 ? 'Köp nu, betala i ' + tm('RESURS_PAY_LATER') : paymentMethod.name }}</span>
				<img v-if="isActive && paymentMethod.icon"
					:src="paymentMethod.icon"
					style="height: 20px; position: relative; max-width: 55px;"
					class="pull-right"
					alt="paymenticon"
				/>
				<span v-else-if="isActive && ! paymentMethod.icon" />
				<span v-else class="pull-right" style="font-weight: bold;">Ändra</span>
			</label>
			<div class="invoice-info" v-if="paymentMethod.id === 34 && isActive && selected">
				<ul class="part-payment-info mt-5">
                    <li>Upp till 60 dagars kredittid, betala i slutet av nästa månad</li>
                    <li>Ingen fakturaavgift</li>
                    <li>Betala och se fakturan i Resurs app</li>
                </ul>
				<span><a target="_blank" v-if="resursPaymentOptions.length" :href="resursPaymentOptions[0].priceInfoUrl">Fullständiga villkor och SEKKI</a></span>
			</div>
			<div class="invoice-info" v-if="paymentMethod.id === 36 && isActive && selected">
				<ul class="part-payment-info mt-5">
					<li>Betala i slutet av {{ tm('RESURS_PAY_LATER') }}</li>
					<li>{{ tm('RESURS_PAY_LATER_FEE') }} kr uppläggningsavgift. Ingen fakturaavgift</li>
					<li>Betala och se fakturan i Resurs app</li>
				</ul>
				<span><a target="_blank" v-if="resursPaymentOptions.length" :href="resursPaymentOptions[1].priceInfoUrl">Fullständiga villkor och SEKKI</a></span>
				<div class="part-payment-warning">
					<ximg
						role="img"
						src="/img/kreditvarning.svg"
						ariaLabel="Warning icon"
					/>
					<h3 class="level-four-heading">Att låna kostar pengar!</h3>
					<p>
						Om du inte kan betala tillbaka hela skulden riskerar du en betalningsanmärkning.
						Det kan leda till svårigheter att få hyra bostad, teckna abonnemang och få nya lån.
						Om du behöver prata med någon om din ekonomi kan du vända dig till budget- och
						skuldrådgivningen i din kommun. Kontaktuppgifter finns på <a href="https://www.konsumentverket.se" target="_blank">konsumentverket.se</a>.
					</p>
				</div>
			</div>
			<span class="sub-title" v-else-if="paymentMethod.id != 34 && isActive && selected">{{ paymentMethod.description }}</span>
		</div>
		<template v-if="hasOptions && selected && isActive && paymentMethod.id === 28">
			<br>
			<dropdown-select
				v-model="selectedDropdownIndex"
				:items="formattedOptions"
				fullWidth
				center
				placeholder="Välj en delbetalningskampanj"
			/>
		</template>
		<template v-if="paymentMethod.id === 35 && selected && isActive">
			<div class="list-group col-xs-12">
				<resursPaymentOption
					v-for="(resursPaymentOption, index) in formattedResursOptions"
					:key="resursPaymentOption.code"
					@click.native="selectResursPaymentMethod(resursPaymentOption, resursPaymentOption.code)"
					:resursPaymentOption="resursPaymentOption"
					:selectedResursPaymentMethodId="selectedResursPaymentMethodId"
					:isLastRow="index === (formattedResursOptions.length - 1)"
					:totalCartSum="totalCartSum"
					:isActive="isActive"
					:index="index"
				/>
			</div>
			<div class="part-payment-warning">
				<ximg
					role="img"
					src="/img/kreditvarning.svg"
					ariaLabel="Warning icon"
				/>
				<h3 class="level-four-heading">Att låna kostar pengar!</h3>
				<p>
					Om du inte kan betala tillbaka hela skulden riskerar du en betalningsanmärkning.
					Det kan leda till svårigheter att få hyra bostad, teckna abonnemang och få nya lån.
					Om du behöver prata med någon om din ekonomi kan du vända dig till budget- och
					skuldrådgivningen i din kommun. Kontaktuppgifter finns på <a href="https://www.konsumentverket.se" target="_blank">konsumentverket.se</a>.
				</p>
			</div>
		</template>
	</div>
</template>

<script>
import { formatPrice, convertToCdnUrl } from 'utils';
import financing from 'utils/financing';
import { t } from 'datastore/i18n';
import localSessionStorage from 'localSessionStorage';
import resursPaymentOption from './resurs-payment-option';

export default {
	data() {
		return {
			optionSelectorOpen: false,
			selectedPaymentOption: null,
			selectedDropdownIndex: null,
			selectedResursPaymentMethodId: null,
		};
	},
	props: {
		paymentMethod: {
			type: Object,
			required: true,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		isLastRow: {
			type: Boolean,
		},
		selectedPaymentMethodId: {
			type: Number,
			default: null,
		},
		selectedVoucherType: {
			type: [Boolean, Array]
		},
		pendingAmount: {
			type: Number,
		},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		resursPaymentOptions: {
			type: Array,
			default: [],
		},
		totalCartSum: {
			type: Number,
		},
		selectFirstPartPaymentOption: {
			type: Boolean,
			default: false,
		}
	},
	components: {
		resursPaymentOption
	},
	mounted() {
		/* Preselects first option in dropdown if corporate customer */
		if (this.selected && this.isCorporateCustomer && this.hasOptions) {
			this.selectedDropdownIndex = 0;
		} else if (this.hasOptions) {
			this.selectOption(null);
		}
	},
	methods: {
		t,
		tm: t.prefix('MONTH'),
		formatPrice,
		selectOption (option) {
			if (option) {
				localSessionStorage.set('checkout:selectedPaymentOption', JSON.stringify(option));
			}
			this.selectedPaymentOption = option;
			this.lastUserSelectedOption = option;
			this.$emit('update:selectedPaymentOption', option);
			this.optionSelectorOpen = false;
		},
		selectResursPaymentMethod (option, id) {
			this.selectedResursPaymentMethodId = id;
			this.selectOption(option);
		},
	},
	computed: {
		formattedOptions () {
			const options = [];
			const totalOrderSum = this.pendingAmount;
			const mapWalley = {};

			for (const campaign of this.paymentMethod.options) {
				mapWalley[campaign.code] = 'Fakturaavgift ' + formatPrice(campaign.invoiceFee, 'SEK');
			}
			// this.availableOptions.forEach((opt, index) => {
			this.paymentMethod.options.forEach((opt, index) => {
				const item = {
					label: opt.name,
					description: mapWalley[opt.code],
					value: index,
				};
				options.push(item);
			});

			return options;
		},
		formattedResursOptions () {
			return this.resursPaymentOptions.filter(opt => opt.code != '0' && opt.code != '11');
		},
		selected () {
			return this.selectedPaymentMethodId === this.paymentMethod.id;
		},
		hasOptions () {
			return this.paymentMethod.options && this.paymentMethod.options.length > 0;
		},
		hasPartPaymentOptions () {
			return this.resursPaymentOptions.some(function(el) {
				return el.code === '2';
			});
		},
		getLowestResursCost () {
			if (this.paymentMethod.id === 35 && this.hasPartPaymentOptions) {
				const lowestPrice = Math.min.apply(Math, this.formattedResursOptions.map(function (event) {
					return event.monthlyCost
				}));
				return formatPrice(lowestPrice, 'SEK');
			}
		},
		disablePayInStore () {
			if (this.selectedVoucherType) {
				return this.selectedVoucherType[0].id === 24 && this.paymentMethod.id === 2;
			}
		}
	},
	watch: {
		selected (to) {
			/**
			* If a paymentMethod with options isn't selected, then reset dropdown value
			* else set option to first in dropdown if selected, has options and is corporate customer
			*/
			if (! to && this.hasOptions) {
				this.selectedDropdownIndex = null;
			} else if (to && this.hasOptions && this.isCorporateCustomer) {
				this.selectedDropdownIndex = 0;
			}
		},
		isActive (to) {
			/* If you go from step four back to payments and isnt corporate customer, reset dropdown value */
			if (to && this.selected && ! this.isCorporateCustomer) {
				this.selectedDropdownIndex = null;
			}
		},
		selectedDropdownIndex (to) {
			/* Checks if 'to' is a number */
			if (isNaN(to)) {
				this.selectOption(null);
			} else {
				this.selectOption(this.paymentMethod.options[to]);
			}
		},
		selectFirstPartPaymentOption () {
			if (this.resursPaymentOptions.length > 1) {
				this.selectedResursPaymentMethodId = this.formattedResursOptions[0].code;
				this.selectOption(this.formattedResursOptions[0]);
			}
		}
	},
};
</script>
